import {
  IGetBusinessPossibleAppointmentsResponse,
  IMappers,
} from '../../../repositories/announcements/v1/get-business-possible-appointments';
import { IApplicationContext } from '../../../types/applicationContext';

export enum EBusinessAppoinmentStatus {
  CriticalError,
  Error,
  Pending,
  Success,
}

export type TBusinessAppoinmentResult = {
  businessAppointments: IGetBusinessPossibleAppointmentsResponse;
  status: EBusinessAppoinmentStatus;
};

export type TBusinessAppoinmentError = {
  businessAppointments: null;
  message: string | null;
  status: EBusinessAppoinmentStatus;
};

export type TBusinessAppoinmentDependencies = Pick<IApplicationContext, 'logger' | 'httpApi'>;

export type TBusinessAppoinmentMappers = IMappers<TBusinessAppoinmentResult, TBusinessAppoinmentError>;

export type TBusinessAppoinment = TBusinessAppoinmentResult | TBusinessAppoinmentError;
